/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAttributionClickFromJSON, ApiAttributionClickToJSON, } from './ApiAttributionClick';
import { ApiBucketFromJSON, ApiBucketToJSON, } from './ApiBucket';
import { ApiChannelFromJSON, ApiChannelToJSON, } from './ApiChannel';
import { ApiExternalAdGroupFromJSON, ApiExternalAdGroupToJSON, } from './ApiExternalAdGroup';
import { ApiExternalCampaignFromJSON, ApiExternalCampaignToJSON, } from './ApiExternalCampaign';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiMatchTypeFromJSON, ApiMatchTypeToJSON, } from './ApiMatchType';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiSessionFromJSON, ApiSessionToJSON, } from './ApiSession';
import { ApiSourceCategoryFromJSON, ApiSourceCategoryToJSON, } from './ApiSourceCategory';
import { ApiSourceFunnelFromJSON, ApiSourceFunnelToJSON, } from './ApiSourceFunnel';
export function ApiSourceFromJSON(json) {
    return ApiSourceFromJSONTyped(json, false);
}
export function ApiSourceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adGroupId': !exists(json, 'adGroupId') ? undefined : json['adGroupId'],
        'adId': !exists(json, 'adId') ? undefined : json['adId'],
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'attributionClicks': !exists(json, 'attributionClicks') ? undefined : (json['attributionClicks'].map(ApiAttributionClickFromJSON)),
        'buckets': !exists(json, 'buckets') ? undefined : (json['buckets'].map(ApiBucketFromJSON)),
        'campaign': !exists(json, 'campaign') ? undefined : json['campaign'],
        'campaignId': !exists(json, 'campaignId') ? undefined : json['campaignId'],
        'campaignNameId': !exists(json, 'campaignNameId') ? undefined : json['campaignNameId'],
        'channel': !exists(json, 'channel') ? undefined : ApiChannelFromJSON(json['channel']),
        'channelId': !exists(json, 'channelId') ? undefined : json['channelId'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'contentNameId': !exists(json, 'contentNameId') ? undefined : json['contentNameId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'externalAdGroup': !exists(json, 'externalAdGroup') ? undefined : ApiExternalAdGroupFromJSON(json['externalAdGroup']),
        'externalAdGroupId': !exists(json, 'externalAdGroupId') ? undefined : json['externalAdGroupId'],
        'externalAdId': !exists(json, 'externalAdId') ? undefined : json['externalAdId'],
        'externalCampaign': !exists(json, 'externalCampaign') ? undefined : ApiExternalCampaignFromJSON(json['externalCampaign']),
        'externalCampaignId': !exists(json, 'externalCampaignId') ? undefined : json['externalCampaignId'],
        'funnel': !exists(json, 'funnel') ? undefined : ApiSourceFunnelFromJSON(json['funnel']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'initialSource': !exists(json, 'initialSource') ? undefined : ApiSourceFromJSON(json['initialSource']),
        'initialSourceId': !exists(json, 'initialSourceId') ? undefined : json['initialSourceId'],
        'leads': !exists(json, 'leads') ? undefined : (json['leads'].map(ApiLeadFromJSON)),
        'matchType': !exists(json, 'matchType') ? undefined : ApiMatchTypeFromJSON(json['matchType']),
        'medium': !exists(json, 'medium') ? undefined : json['medium'],
        'mediumNameId': !exists(json, 'mediumNameId') ? undefined : json['mediumNameId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'sessions': !exists(json, 'sessions') ? undefined : (json['sessions'].map(ApiSessionFromJSON)),
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sourceCategory': !exists(json, 'sourceCategory') ? undefined : ApiSourceCategoryFromJSON(json['sourceCategory']),
        'sourceCategoryId': !exists(json, 'sourceCategoryId') ? undefined : json['sourceCategoryId'],
        'sourceDomain': !exists(json, 'sourceDomain') ? undefined : json['sourceDomain'],
        'sourceNameId': !exists(json, 'sourceNameId') ? undefined : json['sourceNameId'],
        'sourceTitle': !exists(json, 'sourceTitle') ? undefined : json['sourceTitle'],
        'term': !exists(json, 'term') ? undefined : json['term'],
        'termNameId': !exists(json, 'termNameId') ? undefined : json['termNameId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiSourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adGroupId': value.adGroupId,
        'adId': value.adId,
        'analyticsSynced': value.analyticsSynced,
        'attributionClicks': value.attributionClicks === undefined ? undefined : (value.attributionClicks.map(ApiAttributionClickToJSON)),
        'buckets': value.buckets === undefined ? undefined : (value.buckets.map(ApiBucketToJSON)),
        'campaign': value.campaign,
        'campaignId': value.campaignId,
        'campaignNameId': value.campaignNameId,
        'channel': ApiChannelToJSON(value.channel),
        'channelId': value.channelId,
        'content': value.content,
        'contentNameId': value.contentNameId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'externalAdGroup': ApiExternalAdGroupToJSON(value.externalAdGroup),
        'externalAdGroupId': value.externalAdGroupId,
        'externalAdId': value.externalAdId,
        'externalCampaign': ApiExternalCampaignToJSON(value.externalCampaign),
        'externalCampaignId': value.externalCampaignId,
        'funnel': ApiSourceFunnelToJSON(value.funnel),
        'id': value.id,
        'initialSource': ApiSourceToJSON(value.initialSource),
        'initialSourceId': value.initialSourceId,
        'leads': value.leads === undefined ? undefined : (value.leads.map(ApiLeadToJSON)),
        'matchType': ApiMatchTypeToJSON(value.matchType),
        'medium': value.medium,
        'mediumNameId': value.mediumNameId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'sessions': value.sessions === undefined ? undefined : (value.sessions.map(ApiSessionToJSON)),
        'source': value.source,
        'sourceCategory': ApiSourceCategoryToJSON(value.sourceCategory),
        'sourceCategoryId': value.sourceCategoryId,
        'sourceDomain': value.sourceDomain,
        'sourceNameId': value.sourceNameId,
        'sourceTitle': value.sourceTitle,
        'term': value.term,
        'termNameId': value.termNameId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
